// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar__Toolbar__2N0TS","Width":"Toolbar__Width__2gQ9Y","Logo":"Toolbar__Logo__LWn5r"};